import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function WhatsAppIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'WhatsApp',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>WhatsApp</title>
			<rect width="40" height="40" rx="8" fill={bg} />
			<path
				d="M20 8.5C13.65 8.5 8.5 13.56 8.5 19.8c0 2.14.62 4.23 1.78 6.03L9 31.5l5.88-1.53a11.8 11.8 0 0 0 5.12 1.17h.01c6.35 0 11.49-5.06 11.5-11.3 0-3.01-1.18-5.84-3.42-8.01A11.4 11.4 0 0 0 20 8.5Zm0 20.1h-.01a9.7 9.7 0 0 1-4.93-1.34l-.35-.2-3.49.91.94-3.37-.23-.34a9.6 9.6 0 0 1-1.52-5.15A9.67 9.67 0 0 1 20 9.54c5.34 0 9.68 4.25 9.68 9.48A9.67 9.67 0 0 1 20 28.6Z"
				fill={g}
			/>

			<path
				d="M16.55 14.94c-.25-.55-.52-.56-.77-.57h-.66c-.24 0-.6.09-.92.44-.31.34-1.2 1.17-1.2 2.85s1.24 3.3 1.42 3.53c.17.23 2.39 3.79 5.9 5.17 2.91 1.14 3.5.92 4.14.86.63-.06 2.04-.83 2.33-1.63.29-.8.29-1.5.2-1.64-.08-.14-.31-.23-.66-.4s-2.04-.99-2.36-1.1c-.31-.12-.55-.17-.77.17-.23.34-.89 1.11-1.09 1.34-.2.23-.4.26-.75.09-.35-.18-1.46-.53-2.79-1.72-1.03-.92-1.73-2.05-1.93-2.4-.2-.34-.03-.53.16-.71.16-.15.35-.41.53-.61.17-.2.23-.34.35-.57.12-.23.06-.43-.03-.61-.1-.16-.77-1.87-1.07-2.54Z"
				fill={g}
				transform="translate(1.8,-1.9) scale(0.84)"
				style={{ transformOrigin: '10px 21px' }}
			/>
		</svg>
	);
}
